import React from 'react';

import styles from './slide-indicator.style';
import { ThemedText } from '../themed-text';

export function SlideIndicator({ current = 0, total = 0 }) {
  return (
    <ThemedText style={styles.text}>
      {current} / {total}
    </ThemedText>
  );
}
